<h2 mat-dialog-title class="text-center">{{'title.select_sign_method' | translate}}
    <!-- <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
    </button> -->
</h2>

<mat-divider></mat-divider>

<form #f="ngForm" class="mt-3">
    <button
        mat-stroked-button
        color="primary"
        type="button"
        style="margin-left: 24px"
        *ngIf="isHasPermissionAddCert"
        (click)="openDialogAddCert()"
        class="desktop">
        <mat-icon class="mr-0">add_circle</mat-icon>
        {{ "button.add_new_signing_method" | translate }}
    </button>
    <div *ngIf="isPersonalCustomer && !allowOtp" class="pt-3">
        <span style="padding: 0 24px; font-style: italic"
        >{{
            "enterprise_contract.image_signing.not_OTP_for_personal"
                | translate
        }}
        </span>
    </div>

    <mat-dialog-content class="select-certificate">
        <div class="pb-3 pt-2">
            <ng-container
                *ngIf="
                imageCertificates == undefined ||
                    imageCertificates.length == 0;
                else hasCertificates
                "
            >
                <div
                style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                "
                >
                <span>{{
                    "digital_certificate_management.not_exist_certificate"
                        | translate
                    }}</span>
                <span *ngIf="!isHasPermissionAddCert">,
                    {{
                    "digital_certificate_management.please_contact_admin"
                        | translate
                    }}</span
                >
                <span *ngIf="isHasPermissionAddCert">,
                    {{
                    "digital_certificate_management.please_select_add_cert"
                        | translate
                    }}</span
                >
                </div>
            </ng-container>

            <ng-template #hasCertificates>
                <ng-container *ngFor="let item of imageCertificates">
                <mat-expansion-panel
                expanded="true"
                class="mat-elevation-z0"
                *ngIf="item.type == 1 || item.type == 2 || item.type == enumSignMethod.CLOUD_CA"
                >
                <mat-expansion-panel-header
                    class="example-radio-button"
                    [ngSwitch]="item.type"
                    (change)="onSelectImageSignMethod(item.type)"
                    [ngClass]="{
                    'border-none':
                        (!allowOtp && item.type === 3) ||
                        (!allowImage && item.type === 6)
                    }"
                >
                    <mat-panel-title class="mat-panel-title">
                    <ng-container *ngSwitchCase="1">
                        {{
                        "digital_certificate_management.rd_certificate_type.cbx_usb"
                            | translate
                        }}
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                        {{
                        "digital_certificate_management.rd_certificate_type.cbx_sim_ca"
                            | translate
                        }}
                    </ng-container>
                    <ng-container *ngSwitchCase="enumSignMethod.CLOUD_CA">
                        {{
                            "digital_certificate_management.cbx_certificate_type.cbx_cloud_ca"
                                | translate
                        }}
                    </ng-container>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-radio-group
                    aria-labelledby="example-radio-group-label"
                    class="example-radio-group"
                    [(ngModel)]="selectedCert"
                    [ngModelOptions]="{ standalone: true }">
                    <div class="container mat-table-sign-document" *ngIf="item.type != 6 && item.type >= 0">
                    <!-- SIM CA -->
                    <mat-table [dataSource]="item.listCert" *ngIf="item.type == 2">
                        <!-- Chủ thể CTS column -->
                        <ng-container matColumnDef="issuedTo">
                        <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                            style="width: 50%">
                            {{ "digital_certificate_management.issuedTo_name" | translate }}
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let cert"
                            class="mat-cell-non-boder-right-bottom align-middle word-break-line"
                            style="width: 50%"
                            matTooltip="{{ cert.issuedTo }}"
                        >
                            <div class="pre-wrap">
                            <mat-radio-button
                                (change)="onChangeSubType(cert)"
                                class="ml-2 mt-2 mat-header-cell-center"
                                [value]="cert"
                            >
                                <span class="pre-wrap">{{
                                    cert.issuedTo
                                }}</span>
                            </mat-radio-button>
                            </div>
                        </mat-cell>
                        </ng-container>

                        <!-- Serial number column -->
                        <ng-container matColumnDef="serialNumber">
                        <mat-header-cell
                            *matHeaderCellDef
                            class="co-col mat-cell-non-boder-right-bottom"
                            style="max-width: 23%"
                        >
                            {{
                            "digital_certificate_management.serial_title"
                                | translate
                            }}
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let cert"
                            class="mat-cell-non-boder-right-bottom word-break-line"
                            style="max-width: 23%"
                            matTooltip="{{ cert.serialNumber }}"
                        >
                            {{ cert.serialNumber }}
                        </mat-cell>
                        </ng-container>

                        <!-- Mã số thuế column -->
                        <ng-container matColumnDef="taxCode">
                        <mat-header-cell
                            *matHeaderCellDef
                            class="co-col mat-cell-non-boder-right-bottom"
                            style="max-width: 15%"
                        >
                            {{
                            "digital_certificate_management.mst" | translate
                            }}
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let cert"
                            class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                            style="max-width: 15%"
                            matTooltip="{{ cert.taxCode }}"
                        >
                            {{ cert.taxCode }}
                        </mat-cell>
                        </ng-container>

                        <!-- Số điện thoại -->
                        <ng-container matColumnDef="phoneNumber">
                        <mat-header-cell
                            *matHeaderCellDef
                            class="co-col mat-cell-non-boder-right-bottom"
                            style="max-width: 13%"
                        >
                            {{
                            "digital_certificate_management.lbl_phone"
                                | translate
                            }}
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let cert"
                            class="mat-cell-non-boder-right-bottom number-cell-center word-break-line"
                            style="max-width: 13%"
                            matTooltip="{{ cert.phoneNumber }}"
                        >
                            {{ cert.phoneNumber }}
                        </mat-cell>
                        </ng-container>

                        <!-- Ngày hoàn thành column -->
                        <ng-container matColumnDef="expireDate">
                        <mat-header-cell
                            *matHeaderCellDef
                            class="co-col mat-cell-non-boder-bottom"
                            style="max-width: 13%"
                        >
                            {{
                            "headertable.end_of_activate_date" | translate
                            }}
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let cert"
                            class="mat-cell-non-boder-bottom number-cell-center word-break-line"
                            style="max-width: 13%"
                            matTooltip="{{ cert.expireDate | dateformat }}"
                        >
                            {{ cert.expireDate | dateformat }}
                        </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="columnsToDisplaySimCA"
                        ></mat-header-row>
                        <mat-row
                        *matRowDef="let row; columns: columnsToDisplaySimCA"
                        ></mat-row>
                    </mat-table>

                    <!-- Other HSM & Usb Token -->
                    <mat-table [dataSource]="item.listCert" *ngIf="item.type == 1">
                        <!-- Chủ thể CTS column -->
                        <ng-container matColumnDef="issuedTo">
                        <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                            style="width: 50%">
                            {{ "digital_certificate_management.issuedTo_name" | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let cert"
                                    class="mat-cell-non-boder-right-bottom align-middle word-break-line"
                                    style="width: 50%" matTooltip="{{ cert.issuedTo }}">
                            <div class="pre-wrap">
                            <mat-radio-button
                                (change)="onChangeSubType(cert)"
                                class="ml-2 mt-2 mat-header-cell-center"
                                [value]="cert">
                                <span class="pre-wrap">{{cert.issuedTo}}</span>
                            </mat-radio-button>
                            </div>
                        </mat-cell>
                        </ng-container>

                        <!-- Serial number column -->
                        <ng-container matColumnDef="serialNumber">
                        <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                            style="max-width: 25%">
                            {{"digital_certificate_management.serial_title"| translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom word-break-line"
                                    style="max-width: 25%" matTooltip="{{ cert.serialNumber }}">
                            {{ cert.serialNumber }}
                        </mat-cell>
                        </ng-container>

                        <!-- Mã số thuế column -->
                        <ng-container matColumnDef="taxCode">
                        <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                            style="max-width: 15%">
                            {{ "digital_certificate_management.mst" | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let cert"
                                    class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                                    style="max-width: 15%" matTooltip="{{ cert.taxCode }}">
                            {{ cert.taxCode }}
                        </mat-cell>
                        </ng-container>
                        <!-- Ngày hết hiệu lực -->
                        <ng-container matColumnDef="expireDate">
                        <mat-header-cell
                            *matHeaderCellDef
                            class="co-col mat-cell-non-boder-bottom"
                            style="max-width: 13%">{{"headertable.end_of_activate_date" | translate}}
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let cert"
                            class="mat-cell-non-boder-bottom number-cell-center word-break-line"
                            style="max-width: 13%"
                            matTooltip="{{ cert.expireDate | dateformat }}">
                            {{ cert.expireDate | dateformat }}
                        </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="columnsToDisplayOther"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: columnsToDisplayOther"></mat-row>
                    </mat-table>


                    <!--cloud ca-->
                    <mat-table [dataSource]="item.listCert" *ngIf="item.type == enumSignMethod.CLOUD_CA">
                        <!-- Chủ thể CTS column -->
                        <ng-container matColumnDef="issuedTo">
                        <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                            style="width: 50%">
                            {{ "digital_certificate_management.issuedTo_name" | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let cert"
                                    class="mat-cell-non-boder-right-bottom align-middle word-break-line"
                                    style="width: 50%" matTooltip="{{ cert.issuedTo }}">
                            <div class="pre-wrap">
                            <mat-radio-button
                                (change)="onChangeSubType(cert)"
                                class="ml-2 mt-2 mat-header-cell-center"
                                [value]="cert">
                                <span class="pre-wrap">{{cert.issuedTo}}</span>
                            </mat-radio-button>
                            </div>
                        </mat-cell>
                        </ng-container>

                        <!-- Serial number column -->
                        <ng-container matColumnDef="serialNumber">
                        <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                            style="max-width: 25%">
                            {{"digital_certificate_management.serial_title"| translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom word-break-line"
                                    style="max-width: 25%" matTooltip="{{ cert.serialNumber }}">
                            {{ cert.serialNumber }}
                        </mat-cell>
                        </ng-container>

                        <!-- Mã số thuế column -->
                        <ng-container matColumnDef="taxCode">
                        <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                            style="max-width: 15%">
                            {{ "digital_certificate_management.mst" | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let cert"
                                    class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                                    style="max-width: 15%" matTooltip="{{ cert.taxCode }}">
                            {{ cert.taxCode }}
                        </mat-cell>
                        </ng-container>
                        <!-- Tài khoản cloud ca -->
                        <ng-container matColumnDef="cloudCaUsername">
                        <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                            style="max-width: 15%">
                            {{ "digital_certificate_management.cloud_ca_acc" | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let cert"
                                    class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                                    style="max-width: 15%" matTooltip="{{ cert.cloudCaUserId }}">
                            {{ cert.cloudCaUserId }}
                        </mat-cell>
                        </ng-container>

                        <!-- Ngày hết hiệu lực -->
                        <ng-container matColumnDef="expireDate">
                        <mat-header-cell
                            *matHeaderCellDef
                            class="co-col mat-cell-non-boder-right-bottom"
                            style="max-width: 13%">{{"headertable.end_of_activate_date" | translate}}
                        </mat-header-cell>
                        <mat-cell
                            *matCellDef="let cert"
                            class="mat-cell-non-boder-right-bottom number-cell-center word-break-line"
                            style="max-width: 13%"
                            matTooltip="{{ cert.expireDate | dateformat }}">
                            {{ cert.expireDate | dateformat }}
                        </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="hasTransSaved">
                            <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                              class="co-col mat-cell-non-boder-bottom">
                              {{'enterprise_group_user_management.table_headers.save_session_sign' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let cert" style="max-width: 10%;"
                              class="mat-cell-non-boder-bottom number-cell-center word-break-line">
                              <div *ngIf="cert.hasTransSaved == true" [matTooltip]="'button.yes_sign_method_default' | translate" style="color: #09847b">
                                {{ 'button.yes_sign_method_default' | translate }}
                              </div>
                              <div *ngIf="cert.hasTransSaved == false" [matTooltip]="'button.no' | translate" style="color: #da190b">
                                {{ 'button.no' | translate }}
                              </div>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="columnsToDisplayCloudCa"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: columnsToDisplayCloudCa"></mat-row>
                    </mat-table>

                    </div>

                    <div class="container" *ngIf="item.type === 6 && allowImage">
                    <mat-radio-button class="example-radio-button" [value]="item.listCert[0]"
                                        (change)="onSelectImageSignMethod(item.type)"
                                        [disabled]="(!isStillQuantityEkyc && supportEkyc)
                        || (isStillQuantityEkyc && supportEkyc && !isCertificateSupport)">
                    </mat-radio-button>
                    {{'enterprise_contract.image_signing.new_tab.no_select_method_detail' | translate}}<br/>
                    <span class="registered-tab-title-note">{{'enterprise_contract.image_signing.new_tab.step2_note'
                        | translate}}</span>
                    <p class="error-quantity-ekyc"
                        *ngIf="!isStillQuantityEkyc && supportEkyc">{{'digital_certificate_management.quantity_ekyc_not_enough' | translate}}</p>
                    <p class="error-quantity-ekyc"
                        *ngIf="isStillQuantityEkyc && supportEkyc && !isCertificateSupport">
                        {{'digital_certificate_management.certificate_not_support' | translate}}</p>

                    </div>
                </mat-radio-group>
                </mat-expansion-panel>
                </ng-container>
            </ng-template>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button type="submit" color="primary" cdkFocusInitial
            
            (click)="onSelectSignMethod()">
            <mat-icon class="mr-0">gesture</mat-icon>
            {{'button.sign_confirm' | translate}}
        </button>
    </mat-dialog-actions>

    <ng-template #contentEmptyTable let-name> </ng-template>

</form>
